import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { OverlayTrigger, PopOver, Dialog, Radio } from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { settingMap } from './config';
import FeedBackDialog from '../../../common/feedback';
import useFeedback from '../../../../leads_component/shared-components/hooks/useFeedback';
import { withGroupList } from '../../../../cacheAPIData/withGroupList';

const DistributeDedup = () => {
  // eslint-disable-next-line
  const svgPath = 'M5 7C6.10457 7 7 6.10457 7 5V4.5H14.5C14.7761 4.5 15 4.27614 15 4C15 3.72386 14.7761 3.5 14.5 3.5H7V3C7 1.89543 6.10457 1 5 1C3.89543 1 3 1.89543 3 3V3.5H1.5C1.22386 3.5 1 3.72386 1 4C1 4.27614 1.22386 4.5 1.5 4.5H3V5C3 6.10457 3.89543 7 5 7ZM5 2C4.47282 2 4.04092 2.40794 4.00274 2.92537L4 3V5C4 5.55228 4.44772 6 5 6C5.52718 6 5.95908 5.59206 5.99726 5.07463L6 5V3C6 2.44772 5.55228 2 5 2ZM13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11V11.5H1.5C1.22386 11.5 1 11.7239 1 12C1 12.2761 1.22386 12.5 1.5 12.5H9V13C9 14.1046 9.89543 15 11 15C12.1046 15 13 14.1046 13 13V12.5H14.5C14.7761 12.5 15 12.2761 15 12C15 11.7239 14.7761 11.5 14.5 11.5H13V11ZM10.0027 10.9254C10.0409 10.4079 10.4728 10 11 10C11.5523 10 12 10.4477 12 11V13L11.9973 13.0746C11.9591 13.5921 11.5272 14 11 14C10.4477 14 10 13.5523 10 13V11L10.0027 10.9254Z';

  const configMap = {
    /** 关闭分配去重 */
    OFF: 'OFF',
    /** 按归属账号范围去重 */
    ON: 'ON',
    /** 按归因账号范围去重 */
    ON_ATTRIBUTION_ACCOUNT: 'ON_ATTRIBUTION_ACCOUNT',
  };
  const [showConfig, setShowConfig] = useState(false);
  const [configValue, setConfigValue] = useState('');

  const closeConfig = () => {
    setShowConfig(false);
  };

  const openConfig = () => {
    setShowConfig(true);
  };

  const handleSubmit = () => {
    RPCFactory.leadsSetting
      .setLeadsDistributeConfig({ leadsDistriDeduplicate: configValue })
      .done(closeConfig)
      .fail((err) => alert(err));
  };

  const handleConfigChange = (value) => {
    if (value in configMap) {
      setConfigValue(value);
    }
  }

  useEffect(() => {
    if (!showConfig) return;
    RPCFactory.leadsSetting.getLeadsDistributeConfig().done((data) => {
      setConfigValue(data.leadsDistriDeduplicate || '');
    });
  }, [showConfig]);

  return (
    <div className="distri-dedup">
      <OverlayTrigger
        trigger="hover"
        alignment="right"
        placement="left"
        overlay={
          <PopOver>
            您可根据业务需求对重复线索的匹配范围做设置，实现重复线索不再自动分配。
          </PopOver>
        }
      >
        <i className="spaui-icon icon-help" />
      </OverlayTrigger>
      <div className="colored-btn" onClick={openConfig}>
        <svg className="icon-switch" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className="path" fill="#313233" fillRule="evenodd" clipRule="evenodd" d={svgPath} />
        </svg>
        <span className="description-label">线索分配去重</span>
      </div>
      <Dialog
        useNewUI
        title="线索分配去重设置"
        className="distri-config"
        show={showConfig}
        onClose={closeConfig}
        onCancel={closeConfig}
        onSubmit={handleSubmit}
        style={{ width: 600 }}
      >
        <div className="select-item">
          <p className="select-row" onClick={() => handleConfigChange(configMap.ON)}>
            <Radio checked={configValue === configMap.ON} />
            <span className="select-title">按归属账号去重</span>
          </p>
          <p className="weak-text">新线索与该线索归属的账号历史14天内的线索联系电话进行比对，若重复则不分配。</p>
        </div>
        <div className="select-item">
          <p className="select-row" onClick={() => handleConfigChange(configMap.ON_ATTRIBUTION_ACCOUNT)}>
            <Radio checked={configValue === configMap.ON_ATTRIBUTION_ACCOUNT} />
            <span className="select-title">按推广账号去重</span>
          </p>
          <p className="weak-text">新线索与该线索推广的账号历史14天内的线索联系电话进行比对，若重复则不分配。</p>
        </div>
        <div className="select-item">
          <p className="select-row" onClick={() => handleConfigChange(configMap.OFF)}>
            <Radio checked={configValue === configMap.OFF} />
            <span className="select-title">不去重</span>
          </p>
          <p className="weak-text">新线索联系电话重复时，若其和重复的线索命中同分配一规则时，线索默认分配给同一个人；若其和重复线索命中不同分配规则时，按规则所选员工随机分配。</p>
        </div>
      </Dialog>
    </div>
  );
};

const Page = (props) => {
  const [type, setType] = useState('');
  const [selected, setSelected] = useState('');
  const [distributeDeDup, setDistributeDeDup] = useState(true);
  const [distributeSame, setDistributeSame] = useState(false);
  const feedbackHooks = useFeedback();
  const [employeeList, setEmployeeList] = useState([]);
  useEffect(() => {
    RPCFactory.leadsSetting.get().done((data) => {
      setType(data.leadsDistriType);
      setSelected(data.leadsDistriType);
      setDistributeDeDup(data.leadsDistriDeduplicate != 'OFF');
      setDistributeSame(!!data.leadsUnifiedDistributeStatus);
    });

    RPCFactory.employeeManage
      .getEmployees(undefined, undefined, undefined, undefined, undefined, undefined, 0)
      .done((data) => {
        setEmployeeList(data.entities);
      })
      .fail((ret, msg) => {
        feedbackHooks.showErrorTip(`查询失败，错误信息：${msg}`);
      });
  }, []);

  const handleDistriTypeClick = (value) => {
    setSelected(value);
  };

  const onDedupCheckedChange = (e, checked) => {
    RPCFactory.leadsSetting
      .setDistriDeduplicate({
        leadsDistriDeduplicate: checked ? 'ON' : 'OFF',
      })
      .done(() => {
        setDistributeDeDup(checked);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  const onDistrSameCheckedChange = (e, checked) => {
    RPCFactory.leadsSetting
      .setDistriSame({
        leadsUnifiedDistributeStatus: checked ? 1 : 0,
      })
      .done(() => {
        setDistributeSame(checked);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  const apply = (value) => {
    RPCFactory.leadsSetting
      .set({
        leadsDistriType: value,
      })
      .done((resp) => {
        setType(value);
      })
      .fail((status, msg) => {
        feedbackHooks.showErrorTip(msg);
      });
  };

  const handleCancelApply = (value) => {
    RPCFactory.leadsSetting.set({ leadsDistriType: 'MANUAL' })
      .done(() => setType(''))
      .fail((ret, msg) => feedbackHooks.showErrorTip(msg));
  };

  const renderCard = () => (
    <div className="card">
      <div className="panel">
        <div className="panel-heading panel-heading-new">
          <div className="title-and-dedup">
            <p className="panel-title">线索分配方式</p>
            {
              (selected == 'BASIC_RULE' || selected == 'CUSTOMIZED_RULE')
              && (_.get(window, 'pageProps.privileges', []).indexOf('LEADS_DISTRIBUTE_SETTING_VIEW') !== -1)
              && (
                <div className="distri-setting">
                  <DistributeDedup />
                  {/* <div className="distri-dedup">
                    <OverlayTrigger
                      trigger="hover"
                      alignment="right"
                      placement="left"
                      overlay={
                        <PopOver>
                          您可根据业务需求对重复线索的匹配范围做设置，实现重复线索不再自动分配。
                        </PopOver>
                      }
                    >
                      <div className="description-and-icon">
                        <i className="icon-switches" />
                        <span className="description-label">线索分配去重</span>
                        <i className="spaui-icon icon-help" />
                      </div>
                    </OverlayTrigger>
                    <Switch
                      style={{ verticalAlign: '-3px', marginRight: '4px', lineHeight: 1 }}
                      checked={distributeDeDup}
                      onChange={onDedupCheckedChange}
                      disabled={_.get(window, 'pageProps.privileges', []).indexOf('LEADS_DISTRIBUTE_SETTING_MANAGE') === -1 }
                    ></Switch>
                  </div> */}
                </div>)
            }
          </div>
          <ul className="blk-option clearfix">
            {settingMap.map((ele, index) => {
              const isApplied = [type, 'MANUAL'].includes(ele.key);
              return (
                <li
                  key={index}
                  href="javascript:void(0);"
                  className={`option ${isApplied ? 'applied' : ''} ${selected == ele.key ? 'current' : ''}`}
                  onClick={() => {
                    handleDistriTypeClick(ele.key);
                  }}
                >
                  <i className={`icon ${isApplied ? 'icon-blk-selected' : 'icon-blk-select'}`}></i>
                  <div className="item-group">
                    <div className="tt">
                      <em>{ele.title}</em>
                      {isApplied ? (
                        <span className="base-label light-info">
                          <span className="base-label-text">应用中</span>
                        </span>
                      ) : null}
                    </div>
                    <div className="text">{ele.content}</div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
  return (
    <div className="secs">
      <div className="sec">{renderCard()}</div>
      {settingMap.map((ele) =>
        ele.key == selected ? (
          <ele.view
            type={type}
            apply={apply}
            cancelApply={handleCancelApply}
            employeeList={employeeList}
            groupList={props.groupList}
            feedbackHooks={feedbackHooks}
          />
        ) : null,
      )}
      <FeedBackDialog {...feedbackHooks} />
    </div>
  );
};

export default withGroupList(Page);
